import { render } from "./InfoModal.vue?vue&type=template&id=4b307d5c&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=4b307d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b307d5c"]])

export default __exports__